// extracted by mini-css-extract-plugin
export var dark = "bulletedListColumn-module--dark--96207";
export var introText = "bulletedListColumn-module--introText--018f7";
export var light = "bulletedListColumn-module--light--2e7a2";
export var list = "bulletedListColumn-module--list--acda5";
export var wrapper = "bulletedListColumn-module--wrapper--6a1d2";